import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc CallDispositionActivity defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CallDispositionActivityService } from 'services/callDispositionActivity';
 *
 * // create service instance and send/cancel request
 * const callDispositionActivityService = new CallDispositionActivityService();
 * const result = await callDispositionActivityService.fetchData( '<user-id>' ); // fetch data
 * callDispositionActivityService.cancel(); // cancel an active request
 */
export class CallDispositionActivityService extends HttpService {

    // fetch end call widget data
    async fetchComponentData( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        const { patientId } = data;
        
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: {
                    context: { callId, patientId },
                    data: data,
                }
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    items: get( response, 'body.component.data.state.items', {} ),
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
